// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-user-settings-agent-settings-form-module__root--uOgD9 {
  background-color: #7a8794;
  padding: 10px 10px 20px 10px;
}

.src-js-user-settings-agent-settings-form-module__definition--a9Har {
  padding-bottom: 25px;
}

.src-js-user-settings-agent-settings-form-module__formContainer--NPxJC {
  display: flex;
  flex-direction: column;
}

.src-js-user-settings-agent-settings-form-module__inputRowWrapper--CnfjC {
  display: flex;
  padding: 5px 5px;
}

.src-js-user-settings-agent-settings-form-module__inputLabelWrapper--GWyhV {
  display: flex;
  flex: 0 0 160px;
}

.src-js-user-settings-agent-settings-form-module__inputFieldWrapper--wudpY {
  display: flex;
  flex: 0 0 320px;
}

.src-js-user-settings-agent-settings-form-module__linkWrapper--Z5GB3 {
  display: flex;
  justify-content: flex-end;
  padding-top: 25px;
  width: 485px;
}

.src-js-user-settings-agent-settings-form-module__buttonGroupWrapper--sndoU {
  display: flex;
  padding-top: 25px;
  width: 485px;
  justify-content: flex-end;
}

.src-js-user-settings-agent-settings-form-module__buttonWrapper--mrQRD {
  display: flex;
  flex: 0 0 135px;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/js/user/settings/agent-settings-form.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".root {\n  background-color: #7a8794;\n  padding: 10px 10px 20px 10px;\n}\n\n.definition {\n  padding-bottom: 25px;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputRowWrapper {\n  display: flex;\n  padding: 5px 5px;\n}\n\n.inputLabelWrapper {\n  display: flex;\n  flex: 0 0 160px;\n}\n\n.inputFieldWrapper {\n  display: flex;\n  flex: 0 0 320px;\n}\n\n.linkWrapper {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 25px;\n  width: 485px;\n}\n\n.buttonGroupWrapper {\n  display: flex;\n  padding-top: 25px;\n  width: 485px;\n  justify-content: flex-end;\n}\n\n.buttonWrapper {\n  display: flex;\n  flex: 0 0 135px;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-js-user-settings-agent-settings-form-module__root--uOgD9`,
	"definition": `src-js-user-settings-agent-settings-form-module__definition--a9Har`,
	"formContainer": `src-js-user-settings-agent-settings-form-module__formContainer--NPxJC`,
	"inputRowWrapper": `src-js-user-settings-agent-settings-form-module__inputRowWrapper--CnfjC`,
	"inputLabelWrapper": `src-js-user-settings-agent-settings-form-module__inputLabelWrapper--GWyhV`,
	"inputFieldWrapper": `src-js-user-settings-agent-settings-form-module__inputFieldWrapper--wudpY`,
	"linkWrapper": `src-js-user-settings-agent-settings-form-module__linkWrapper--Z5GB3`,
	"buttonGroupWrapper": `src-js-user-settings-agent-settings-form-module__buttonGroupWrapper--sndoU`,
	"buttonWrapper": `src-js-user-settings-agent-settings-form-module__buttonWrapper--mrQRD`
};
export default ___CSS_LOADER_EXPORT___;
